module.exports = __webpack_public_path__ + "static/media/tv.eda22a5d.svg";